export function buildOrderStatusTimelineEvents(order) {
  const history = order?.status_history;
  if (history && history.length > 0) {
    return [...history].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  }
  const events = [];
  if (order?.created_at) {
    events.push({ status: 'DRAFT', previous_status: null, created_at: order.created_at });
  }
  if (order?.updated_at && order?.created_at !== order?.updated_at && order?.status !== 'DRAFT') {
    events.push({
      status: order.status,
      previous_status: 'DRAFT',
      created_at: order.updated_at,
    });
  }
  return events.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
}
